import { render, staticRenderFns } from "./FacebookButton.vue?vue&type=template&id=71fb645c&scoped=true&"
import script from "./facebook-button.ts?vue&type=script&lang=ts&"
export * from "./facebook-button.ts?vue&type=script&lang=ts&"
import style0 from "./FacebookButton.vue?vue&type=style&index=0&id=71fb645c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb645c",
  null
  
)

export default component.exports